import {
  Destination,
  DestinationsResponse,
  CreateDestinationPayload,
  UpdateDestinationPayload,
} from '@/types/greenroom/destination.types';
import { Get, Post, Put, Delete } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const HEADERS = {
  'bl-global-resource': 'false',
};

export function GetDestinations(meetingId: string): Promise<DestinationsResponse | null> {
  return Get({
    host: GREENROOM_HOST,
    url: `/v3/greenroom/${meetingId}/destination`,
    includeGreenroomToken: true,
    headers: HEADERS,
  });
}

export function CreateDestination(meetingId: string, payload: CreateDestinationPayload): Promise<Destination | null> {
  return Post({
    host: GREENROOM_HOST,
    url: `/v3/greenroom/${meetingId}/destination`,
    body: payload,
    includeGreenroomToken: true,
    headers: HEADERS,
  });
}

export function UpdateDestination(meetingId: string, payload: UpdateDestinationPayload): Promise<Destination | null> {
  return Put({
    host: GREENROOM_HOST,
    url: `/v3/greenroom/${meetingId}/destination`,
    body: payload,
    includeGreenroomToken: true,
    headers: HEADERS,
  });
}

export function DeleteDestination(meetingId: string, destinationId: string): Promise<void> {
  return Delete({
    url: `/v3/greenroom/${meetingId}/destination/${destinationId}`,
    host: GREENROOM_HOST,
    includeGreenroomToken: true,
    headers: HEADERS,
  });
}
